import './Fees.css';

export const Fees = () => {
  return (
    <>
      <section className="snn-page-section">
        <h1 className="snn-title">Registration Fees</h1>
        <table className="snn-table-fees">
          <thead>
            <tr>
              <th></th>
              <th>Student</th>
              <th>
                Researcher/
                <br />
                Postdoc
              </th>
              <th>Company worker</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Early Bird, April 6 to April 30, 2026</td>
              <td className="snn-prices-cell">$800.00</td>
              <td className="snn-prices-cell">$1,600.00</td>
              <td className="snn-prices-cell">$3,000.00</td>
            </tr>
            <tr>
              <td>After April 30th, 2026</td>
              <td className="snn-prices-cell">$1,100.00</td>
              <td className="snn-prices-cell">$2,200.00</td>
              <td className="snn-prices-cell">$4,500.00</td>
            </tr>
          </tbody>
        </table>
        <p>Note: Registration Fees in Mexican pesos</p>
      </section>
      <section className="snn-page-section">
        <h1 className="snn-title">Fellowships</h1>
        <p>
          <strong>Attention students:</strong> Undergraduate, master’s, and doctoral students with accepted abstracts
            who present their work may be eligible for a scholarship covering the registration fee.
            The scholarship application system will open on our website in April. Please note that scholarships are limited,
            and recipients will be selected by the Organizing Committee. Applicants will be required to provide current
            proof of student status.
        </p>
      </section>
    </>
  );
};
